import InterviewTable from './interview-table';
export default InterviewTable;